import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useEstimateStore = create()(
    persist(
        (set) => ({
            // State
            page: 0,
            rowsPerPage: 10,
            search: '',
            tabValue: 0,
            type: '',
            dateData: '',
            selectDate: null,
            yearData: '',
            makeData: '',
            modelData: '',
            licenseNumber: '',
            fleetUnitNumber: '',
            provinceId: '',
            vinFilter: '',
            sortStatus: 'DSC',
            sortByName: 'createdAt',
            sortTypeTotal: '',
            showEstimateLicensePlateColumn: false,
            showEstimateUnitColumn: false,
            estimateCheckboxes: {
                EST: false,
                ESTR: false,
            },

            // Setters
            setPage: (page) => set({ page }),
            setRowsPerPage: (rowsPerPage) => set({ rowsPerPage }),
            setSearch: (search) => set({ search }),
            setTabValue: (tabValue) => set({ tabValue }),
            setType: (type) => set({ type }),
            setDateData: (dateData) => set({ dateData }),
            setSelectDate: (selectDate) => set({ selectDate }),
            setYearData: (yearData) => set({ yearData }),
            setMakeData: (makeData) => set({ makeData }),
            setModelData: (modelData) => set({ modelData }),
            setLicenseNumber: (licenseNumber) => set({ licenseNumber }),
            setFleetUnitNumber: (fleetUnitNumber) => set({ fleetUnitNumber }),
            setProvinceId: (provinceId) => set({ provinceId }),
            setVinFilter: (vinFilter) => set({ vinFilter }),
            setSortStatus: (sortStatus) => set({ sortStatus }),
            setSortByName: (sortByName) => set({ sortByName }),
            setSortTypeTotal: (sortTypeTotal) => set({ sortTypeTotal }),
            setShowEstimateLicensePlateColumn: (showEstimateLicensePlateColumn) => set({ showEstimateLicensePlateColumn }),
            setShowEstimateUnitColumn: (showEstimateUnitColumn) => set({ showEstimateUnitColumn }),
            resetEstimateTableColumns: () =>
                set({
                    showEstimateLicensePlateColumn: false,
                    showEstimateUnitColumn: false,
                }),
            setEstimateCheckboxes: (estimateCheckboxes) => set({ estimateCheckboxes }),

            resetEstimateStore: () =>
                set((state) => ({
                    page: 0,
                    rowsPerPage: 10,
                    search: '',
                    tabValue: 0,
                    type: '',
                    dateData: '',
                    selectDate: null,
                    yearData: '',
                    makeData: '',
                    modelData: '',
                    licenseNumber: '',
                    fleetUnitNumber: '',
                    provinceId: '',
                    vinFilter: '',
                    sortStatus: 'DSC',
                    sortByName: 'createdAt',
                    sortTypeTotal: '',
                    showEstimateLicensePlateColumn: state.showEstimateLicensePlateColumn,
                    showEstimateUnitColumn: state.showEstimateUnitColumn,
                    estimateCheckboxes: {
                        EST: false,
                        ESTR: false,
                    },
                })),
        }),
        {
            name: 'estimate-store',
        }
    )
);

export default useEstimateStore;
